import { DOCUMENT } from '@angular/common';
import { Inject, Injectable } from '@angular/core';
import { OrganizationConfigService } from '../configs/organization-config.service';
import { ScriptInjectorService } from '../script-injector/script-injector.service';

@Injectable({
  providedIn: 'root'
})
export class AdobeAnalyticsService {
  private scriptLoaded = false;

  constructor(private configService: OrganizationConfigService,
      private scriptInjectorSvc : ScriptInjectorService,
      @Inject(DOCUMENT) private document: Document) {}

    loadAdobeAnalytics(): void {
      if (this.configService.isAdobeAnalyticsEnabled && this.configService.adobeAnalyticsScriptUrl && !this.scriptLoaded) {

        this.scriptInjectorSvc.injectScript({
          id: 'adobe-analytics',
          url: this.configService.adobeAnalyticsScriptUrl,
          type: 'text/javascript',
          appendTo: 'head',
          async: true,
          onloadCallback: () => window.digitalData = window.digitalData || {}
        })

        this.scriptLoaded = true;
      }
    }

    updateAdobeAnalyticsMetaData(){
      if(this.configService.isAdobeAnalyticsEnabled){
        window.digitalData = window.digitalData || {};
        const pageName = `nfo:digitalinvestor:${this.document.title.replace(/\s+/g, "-").toLowerCase()}`; 
        window.digitalData = {
          page: {
            pageInfo: {
              pageName: pageName
            },
          },

          applicationInfo: {
            applicationType: "Digital Investor",
          },

          user: {
            attributes: {
              analyticid: localStorage.getItem("analyticid"),
            },
          },
        };
      }
    }
}
